// extracted by mini-css-extract-plugin
export default {"container":"layer_container__QayMV","is-fixed":"layer_is-fixed__xS3qt","translucent-background":"layer_translucent-background__G-eqL","no-scroll":"layer_no-scroll__dJio5"};